var render, staticRenderFns
import script from "./tabsName.vue?vue&type=script&lang=jsx"
export * from "./tabsName.vue?vue&type=script&lang=jsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports